export default __webpack_public_path__ + "static/media/p3Pic.c3b65369.JPG";